import React from 'react';
import { IMitekCaptureResult, useMitekContext } from '../../../providers/MitekProvider/MitekProvider';
import './DriversLicense.css';

import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import SessionStorage from '../../../utils/SessionStorage';
import { useMitekSubmit } from '../../../providers/MitekProvider/MitekDocumentsSubmit';
import { useMitekSubmit as useMitekSubmitModern } from '../../../providers/MitekProvider/MitekDocumentsSubmitModern';
import { IMitekFlowComponentProps } from '../MitekFlow';
import { VerifyIdentificationDocumentResponse } from 'types/responses/VerifyIdentificationDocumentResponse';
import { DynamicResponse } from 'utils/api-utils/api-utils';
import { Button, Row, Col, Image, Container } from '../../../importCL';

export interface IDriversLicenseProps extends IMitekFlowComponentProps {
    isFront: boolean;
}

const DriversLicense = (props: IDriversLicenseProps) : JSX.Element => {
    const { startCapture, MitekConfiguration, MitekProps } = useMitekContext();
    const { fullMitekSubmit } = useMitekSubmit();
    const { fullMitekSubmit: fullMitekSubmitModern } = useMitekSubmitModern();

    const captureCallback = async (result: IMitekCaptureResult) => {
        if (result.successful) {
            if (props.isFront) {
                props.setFlowStage('DriversLicenseBack');
            } else {
                const selfieRequired = SessionStorage.get('useFaceBiometric');
                if (selfieRequired && selfieRequired === 'true') {
                    props.setFlowStage('Selfie');
                } else {
                    props.setSpinning(true);
                    
                    await ( MitekProps.usingModernApi ? fullMitekSubmitModern : fullMitekSubmit )(
                        { 
                            onFailure: (response?: DynamicResponse<VerifyIdentificationDocumentResponse>): void => {
                                if (response?.data?.IsRetake === true) {
                                    props.setFlowStage('ResultsFailure');
                                    props.setSpinning(false);
                                }
                            },
                            onSuccess: (response?: DynamicResponse<VerifyIdentificationDocumentResponse>) => {
                                if (response?.data?.IsRetake === true) {
                                    props.setFlowStage('ResultsFailure');
                                    props.setSpinning(false);
                                } else if (!MitekConfiguration.current.isMobileOnlySession) {
                                    props.setFlowStage('ResultsSuccess');
                                    props.setSpinning(false);
                                }
                            },
                        });

                }
            }
            
        }
    };

    const handleOnClick = () => {
        startCapture(captureCallback);
    };

    return (
        <Container id='mitek-flow-drivers-license' className='MitekFlowDriversLicense MitekFlowDriversLicense__container'>
            {props.mainTitle &&  
                <Row>
                    <Col>
                        <div className='MitekFlowDriversLicense__mainTitle'>{props.mainTitle}</div>
                    </Col>
                </Row>
            }
            {props.subtitle && 
                <Row>
                    <Col>
                        <div className='MitekFlowDriversLicense__subtitle'>{transformHTMLParserLinks(props.subtitle)}</div>
                    </Col>
                </Row>
            }
            {props.imgPath &&
                <Row>
                    <Col>
                        <Image 
                            loading='lazy'
                            className='MitekFlowDriversLicense__mainImage'
                            src={props.imgPath}
                            alt={props.imgAltText}
                        />        
                    </Col>
                </Row>
            }
            {props.description &&
                <Row>
                    <Col>
                        <div className='MitekFlowDriversLicense__description'>{transformHTMLParserLinks(props.description)}</div>
                    </Col>
                </Row>
            }
            <Row>
                <Col>
                    <Button 
                        className='MitekFlowDriversLicense__ctaButton' 
                        onClick={handleOnClick} 
                        size='medium'>
                        {props.ctaButtonText}
                    </Button>
                </Col>
            </Row>
        </Container>);
};

export default DriversLicense;